import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionMarkRound = _resolveComponent("QuestionMarkRound")!
  const _component_StudentInClass = _resolveComponent("StudentInClass")!
  const _component_Math = _resolveComponent("Math")!
  const _component_Notepad = _resolveComponent("Notepad")!
  const _component_Splash = _resolveComponent("Splash")!
  const _component_Correct = _resolveComponent("Correct")!
  const _component_Wrong = _resolveComponent("Wrong")!
  const _component_Skip = _resolveComponent("Skip")!
  const _component_SpinnerSolid = _resolveComponent("SpinnerSolid")!
  const _component_RightArrow = _resolveComponent("RightArrow")!
  const _component_Warning = _resolveComponent("Warning")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_Hamburger = _resolveComponent("Hamburger")!
  const _component_CorrectRounded = _resolveComponent("CorrectRounded")!
  const _component_WrongRounded = _resolveComponent("WrongRounded")!
  const _component_SkipRounded = _resolveComponent("SkipRounded")!
  const _component_PartiallyCorrect = _resolveComponent("PartiallyCorrect")!
  const _component_PartiallyCorrectRounded = _resolveComponent("PartiallyCorrectRounded")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($props.iconClass)
  }, [
    ($props.name == 'question-mark-round')
      ? (_openBlock(), _createBlock(_component_QuestionMarkRound, { key: 0 }))
      : _createCommentVNode("", true),
    ($props.name == 'student-in-class')
      ? (_openBlock(), _createBlock(_component_StudentInClass, { key: 1 }))
      : _createCommentVNode("", true),
    ($props.name == 'math')
      ? (_openBlock(), _createBlock(_component_Math, { key: 2 }))
      : _createCommentVNode("", true),
    ($props.name == 'notepad')
      ? (_openBlock(), _createBlock(_component_Notepad, { key: 3 }))
      : _createCommentVNode("", true),
    ($props.name == 'splash')
      ? (_openBlock(), _createBlock(_component_Splash, { key: 4 }))
      : _createCommentVNode("", true),
    ($props.name == 'correct')
      ? (_openBlock(), _createBlock(_component_Correct, { key: 5 }))
      : _createCommentVNode("", true),
    ($props.name == 'wrong')
      ? (_openBlock(), _createBlock(_component_Wrong, { key: 6 }))
      : _createCommentVNode("", true),
    ($props.name == 'skip')
      ? (_openBlock(), _createBlock(_component_Skip, { key: 7 }))
      : _createCommentVNode("", true),
    ($props.name == 'spinner-solid')
      ? (_openBlock(), _createBlock(_component_SpinnerSolid, { key: 8 }))
      : _createCommentVNode("", true),
    ($props.name == 'right-arrow')
      ? (_openBlock(), _createBlock(_component_RightArrow, { key: 9 }))
      : _createCommentVNode("", true),
    ($props.name == 'warning')
      ? (_openBlock(), _createBlock(_component_Warning, { key: 10 }))
      : _createCommentVNode("", true),
    ($props.name == 'lock')
      ? (_openBlock(), _createBlock(_component_Lock, { key: 11 }))
      : _createCommentVNode("", true),
    ($props.name == 'hamburger')
      ? (_openBlock(), _createBlock(_component_Hamburger, { key: 12 }))
      : _createCommentVNode("", true),
    ($props.name == 'correct-rounded')
      ? (_openBlock(), _createBlock(_component_CorrectRounded, { key: 13 }))
      : _createCommentVNode("", true),
    ($props.name == 'wrong-rounded')
      ? (_openBlock(), _createBlock(_component_WrongRounded, { key: 14 }))
      : _createCommentVNode("", true),
    ($props.name == 'skip-rounded')
      ? (_openBlock(), _createBlock(_component_SkipRounded, { key: 15 }))
      : _createCommentVNode("", true),
    ($props.name == 'partially-correct')
      ? (_openBlock(), _createBlock(_component_PartiallyCorrect, { key: 16 }))
      : _createCommentVNode("", true),
    ($props.name == 'partially-correct-rounded')
      ? (_openBlock(), _createBlock(_component_PartiallyCorrectRounded, { key: 17 }))
      : _createCommentVNode("", true)
  ], 2))
}